import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class MyMessageService extends MessageService {
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    super();
    this.language = 'en-US';
  }

  private data: object = {};

  public set language(value: string) {
    if (this.cookieService.check('access_token')) {
      const url = this.apiUrl + 'api/v2/Language/Translations/messages';

      this.http.get(url).subscribe((c) => {
        this.data = c;
        this.notify();
      });
    }
  }

  public get language(): string {
    return this.localeId;
  }

  private localeId = 'en-US';

  private get messages(): any {
    return this.data;
  }

  public override get(key: string): string {
    return this.messages[key];
  }
}
